// config.js
const baseURL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8002"
    : "https://api.easygorcs.com";

export default baseURL;
